import React, { useState } from 'react';
import TopBanner from '../../components/TopBanner';
import { Link } from 'react-router-dom';
import Accordion from 'react-bootstrap/Accordion';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons'; 
// import ContentUnderWork from '../../components/ContentUnderWork';

export default function AIMLDevelopment() {

    const homeimg = '/images/service/ai-ml-development.png';
    const server_url = process.env.REACT_APP_SERVER;

    const schemaData = {
        "@context": "https://schema.org",
        "@type": "Service",
        "serviceType": "AI/ML Development",
        "provider": {
            "@type": "Organization",
            "name": "Lurantech",
            "url": "https://lurantech.com",
            "logo": "https://lurantech.com/images/logo.png",
            "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+91-7226-999-101",
                "contactType": "Customer Service",
                "areaServed": "IN",
                "availableLanguage": "English"
            },
            "sameAs": [
                "https://www.facebook.com/Lurantech-107968334690860",
                "https://www.linkedin.com/company/lurantech",
                "https://x.com/lurantech"
            ],
            "address": {
                "@type": "PostalAddress",
                "streetAddress": "FF-401, 4th Floor, 7 Sky Complex, Laxmipura, Near VUDA Cross Road",
                "addressLocality": "Vadodara",
                "addressRegion": "Gujarat",
                "postalCode": "390021",
                "addressCountry": "IN"
            }
        },
        "description": "Unlock innovation with our AI/ML development services, delivering intelligent, data-driven solutions for enhanced decision-making and efficiency.",
        "serviceAudience": {
            "@type": "Audience",
            "audienceType": "Business Clients"
        },
        "offers": [
            {
                "@type": "Offer",
                "priceCurrency": "INR",
                "price": "Contact for pricing",
                "eligibleRegion": {
                    "@type": "Place",
                    "name": "India"
                },
                "url": "https://lurantech.com/service/ai-ml-development"
            }
        ]
    }

    const [expanded, setExpanded] = useState(false);

    const handleAccordionToggle = () => {
        setExpanded(!expanded);
    };

    return (
        <>
            {/* <ContentUnderWork /> */}
            <HelmetProvider>
                <Helmet>
                    <meta property="og:title" content="LuranTech | AI/ML Development | Data-Driven Intelligent Solutions" />
                    <meta property="og:description" content="Unlock innovation with LuranTech’s AI/ML development services to deliver intelligent, data-driven solutions for enhanced decision-making and operational efficiency." />
                    <meta property="og:image" content={`${server_url}${homeimg}`} />
                    <meta property="og:url" content="https://lurantech.com/service/ai-ml-development" />
                    <meta property="og:type" content="website" />
                    <meta property="og:image:type" content="image/jpeg" />
                    <meta property="og:image:width" content="1200" />
                    <meta property="og:image:height" content="675" />

                    <meta name="twitter:title" content="LuranTech | AI/ML Development | Data-Driven Intelligent Solutions" />
                    <meta name="twitter:description" content="Unlock innovation with LuranTech’s AI/ML development services to deliver intelligent, data-driven solutions for enhanced decision-making and operational efficiency." />
                    <meta name="twitter:image" content={`${server_url}${homeimg}`} />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta property="twitter:image:type" content="image/jpeg" />
                    <meta property="twitter:image:width" content="1200" />
                    <meta property="twitter:image:height" content="675" />

                    <meta name="robots" content="index, follow" />
                    <meta name="description" content="Unlock innovation with LuranTech’s AI/ML development services to deliver intelligent, data-driven solutions for enhanced decision-making and operational efficiency." />
                    <meta name="keywords" content="AI Development, ML Development, Artificial Intelligence, Machine Learning, Data Analytics, Predictive Analytics, AI Solutions, ML Solutions, AI-powered automation, Data-driven solutions" />
                    <meta name="author" content="LuranTech" />
                    <link rel="canonical" href="https://lurantech.com/service/ai-ml-development" />
                    <title>LuranTech | AI/ML Development | Data-Driven Intelligent Solutions</title>
                </Helmet>

                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(schemaData),
                    }}
                />
                
                <TopBanner title="AI/ML Development" />
                <div className="it-sol-con">
                    <p>At LuranTech, we specialize in providing cutting-edge <strong>AI and ML Development</strong> services that empower businesses to harness the full potential of their data. Our solutions deliver intelligent, data-driven results that streamline operations, enhance decision-making, and improve overall business efficiency. Whether you're looking to integrate AI into your existing systems or build custom ML models, we provide tailored solutions to meet your unique business needs.</p>
                    <br />
                    <div className='row g-4'>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <section className="service-section">
                                <div className='row g-2 p-2'>
                                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4" style={{textAlign: 'center'}}>
                                        <img src="/images/icons/ai-ml-services-1.png" alt="" style={{width: '100px'}} />
                                    </div>
                                    <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 d-flex align-items-center justify-content-center">
                                        <h3>AI-Powered Automation</h3>
                                    </div>
                                    <hr />
                                    <Accordion>
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header onClick={handleAccordionToggle}>{expanded ? <ChevronUp /> : <ChevronDown />}<span className='truncate-2'>Leverage AI to automate complex processes, reducing human intervention and improving operational efficiency. From predictive analytics to intelligent decision-making systems, our AI solutions can help your business become more agile and competitive in the digital age.</span></Accordion.Header>
                                            <Accordion.Body>Leverage AI to automate complex processes, reducing human intervention and improving operational efficiency. From predictive analytics to intelligent decision-making systems, our AI solutions can help your business become more agile and competitive in the digital age.</Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <p><strong>Key Benefits of AI-Powered Automation:</strong></p>
                                        <ul>
                                            <li><strong>Process Efficiency: </strong>Reduce time and costs by automating routine and complex processes.</li>
                                            <li><strong>Data-Driven Decisions: </strong>Make faster, more accurate business decisions with AI-based insights.</li>
                                            <li><strong>Competitive Edge: </strong>Stay ahead of the competition by embracing cutting-edge AI technologies.</li>
                                        </ul>
                                    </div>
                                </div>
                            </section>
                        </div>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <section className="service-section">
                                <div className='row g-2 p-2'>
                                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4" style={{textAlign: 'center'}}>
                                        <img src="/images/icons/ai-ml-services-2.png" alt="" style={{width: '100px'}} />
                                    </div>
                                    <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 d-flex align-items-center justify-content-center">
                                        <h3>Machine Learning Model Development</h3>
                                    </div>
                                    <hr />
                                    <Accordion>
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header onClick={handleAccordionToggle}>{expanded ? <ChevronUp /> : <ChevronDown />}<span className='truncate-2'>Our machine learning model development services help you create predictive models tailored to your data. Whether you're working on classification, regression, or recommendation systems, we provide the expertise to build and deploy custom models that drive actionable insights for your business.</span></Accordion.Header>
                                            <Accordion.Body>Our machine learning model development services help you create predictive models tailored to your data. Whether you're working on classification, regression, or recommendation systems, we provide the expertise to build and deploy custom models that drive actionable insights for your business.</Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <p><strong>Key Benefits of Machine Learning Models:</strong></p>
                                        <ul>
                                            <li><strong>Predictive Analytics: </strong>Forecast trends and outcomes using historical data.</li>
                                            <li><strong>Personalized Recommendations: </strong>Provide customized recommendations to enhance user engagement.</li>
                                            <li><strong>Business Intelligence: </strong>Gain deeper insights into business operations and customer behavior.</li>
                                        </ul>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                    <br />
                    <br />
                    <div className='row g-4'>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <section className="service-section">
                                <div className='row g-2 p-2'>
                                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4" style={{textAlign: 'center'}}>
                                        <img src="/images/icons/ai-ml-services-3.png" alt="" style={{width: '100px'}} />
                                    </div>
                                    <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 d-flex align-items-center justify-content-center">
                                        <h3>Natural Language Processing (NLP)</h3>
                                    </div>
                                    <hr />
                                    <Accordion>
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header onClick={handleAccordionToggle}>{expanded ? <ChevronUp /> : <ChevronDown />}<span className='truncate-2'>Unlock the power of human language with our NLP services. Whether you're building chatbots, sentiment analysis tools, or advanced language models, we leverage AI to enable seamless interaction between machines and humans.</span></Accordion.Header>
                                            <Accordion.Body>Unlock the power of human language with our NLP services. Whether you're building chatbots, sentiment analysis tools, or advanced language models, we leverage AI to enable seamless interaction between machines and humans.</Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <p><strong>Key Benefits of NLP:</strong></p>
                                        <ul>
                                            <li><strong>Enhanced User Interaction: </strong>Create intelligent, responsive chatbots for customer support.</li>
                                            <li><strong>Sentiment Analysis: </strong>Gain insights into customer emotions and preferences through NLP.</li>
                                            <li><strong>Content Automation: </strong>Automatically process and categorize text data for improved efficiency.</li>
                                        </ul>
                                    </div>
                                </div>
                            </section>
                        </div>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <section className="service-section">
                                <div className='row g-2 p-2'>
                                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4" style={{textAlign: 'center'}}>
                                        <img src="/images/icons/ai-ml-services-4.png" alt="" style={{width: '100px'}} />
                                    </div>
                                    <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 d-flex align-items-center justify-content-center">
                                        <h3>Computer Vision Solutions</h3>
                                    </div>
                                    <hr />
                                    <Accordion>
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header onClick={handleAccordionToggle}>{expanded ? <ChevronUp /> : <ChevronDown />}<span className='truncate-2'>Utilize computer vision to analyze visual data and make intelligent decisions. From image recognition to object detection, we provide AI-driven solutions to automate visual data analysis in various applications.</span></Accordion.Header>
                                            <Accordion.Body>Utilize computer vision to analyze visual data and make intelligent decisions. From image recognition to object detection, we provide AI-driven solutions to automate visual data analysis in various applications.</Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <p><strong>Key Benefits of Computer Vision:</strong></p>
                                        <ul>
                                            <li><strong>Image & Object Recognition: </strong>Enable automation in areas like security and manufacturing.</li>
                                            <li><strong>Real-Time Monitoring: </strong>Analyze and act on visual data in real time.</li>
                                            <li><strong>Accuracy & Precision: </strong>Improve accuracy in various fields such as healthcare and automotive.</li>
                                        </ul>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                    <br />
                    <h2>Why Choose LuranTech for AI/ML Development?</h2>
                    <p>With over 20 years of experience, LuranTech is your trusted partner for AI and ML development. We specialize in building robust, scalable AI/ML solutions that drive innovation and transform your business. Whether you're looking to improve efficiency, make data-driven decisions, or enhance user experiences, our team is equipped with the right expertise and tools to make it happen.</p>
                    <p>We offer end-to-end services including:</p>
                    <ul>
                        <li><strong>AI & ML Strategy: </strong>Assess your goals and implement the most effective AI/ML solutions.</li>
                        <li><strong>Custom Model Development: </strong>Create tailored AI and ML models for your unique business requirements.</li>
                        <li><strong>Data Analytics: </strong>Unlock valuable insights from your data to support strategic decision-making.</li>
                    </ul>
                    <hr />
                    <p>Ready to unlock innovation and improve efficiency with AI/ML? <Link style={{fontWeight:'600', color:'#232323', textDecoration:'underline'}} to='/contact-us'>Contact us today</Link> to discuss how we can help your business grow.</p>
                    <span style={{fontSize:'10px'}}>All icons by <a target="_blank" rel="noreferrer" href="https://icons8.com">Icons8</a></span>
                </div>
            </HelmetProvider>


        </>
    );
}
